import * as React from "react"
import { Slot } from "@radix-ui/react-slot"
import { cva } from "class-variance-authority";

import { cn } from "../../lib/utils"

const buttonVariants = cva(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-lg text-sm font-medium transition-all duration-300 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#00f4ff] focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
  {
    variants: {
      variant: {
        default:
          "bg-gradient-to-r from-[#00f4ff] to-[#12b7ff] text-[#040816] font-semibold shadow-lg shadow-[#00f4ff]/25 hover:shadow-xl hover:shadow-[#00f4ff]/40 hover:scale-105 active:scale-95",
        destructive:
          "bg-gradient-to-r from-red-500 to-red-600 text-white shadow-lg shadow-red-500/25 hover:shadow-xl hover:shadow-red-500/40 hover:scale-105 active:scale-95",
        outline:
          "border-2 border-[#00f4ff]/40 bg-transparent text-[#00f4ff] shadow-sm hover:bg-[#00f4ff]/10 hover:border-[#00f4ff] hover:shadow-lg hover:shadow-[#00f4ff]/20 backdrop-blur-sm",
        secondary:
          "bg-[#0b1c38] text-[#9EB4C0] border border-[#9EB4C0]/20 shadow-sm hover:bg-[#0C1A2A] hover:text-[#00f4ff] hover:border-[#00f4ff]/40 hover:shadow-md",
        ghost: "hover:bg-[#00f4ff]/10 hover:text-[#00f4ff]",
        link: "text-[#00f4ff] underline-offset-4 hover:underline hover:text-[#12b7ff]",
      },
      size: {
        default: "h-10 px-5 py-2",
        sm: "h-9 rounded-lg px-4 text-xs",
        lg: "h-12 rounded-lg px-8 text-base",
        icon: "h-10 w-10",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
)

const Button = React.forwardRef(({ className, variant, size, asChild = false, ...props }, ref) => {
  const Comp = asChild ? Slot : "button"
  return (
    <Comp
      className={cn(buttonVariants({ variant, size, className }))}
      ref={ref}
      {...props} />
  );
})
Button.displayName = "Button"

export { Button, buttonVariants }
